module.exports = __webpack_public_path__ + "static/media/clients.b3dfcaa5.svg";